// TODO: All tenants seems to have different breakpoint values on the website
export default {
  desktop: 1075,
  tablet: 700,
  phone: 500,
};
